exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".incidents {\n  margin-bottom: 1.5rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/client/client-incidents/client-incidents.component.css
// module id = ../../../../../src/app/_components/client/client-incidents/client-incidents.component.css
// module chunks = main